<script setup lang="ts">
import Header from '#components/base/Header.vue';
import Footer from '#components/base/Footer.vue';
</script>

<template>
  <div class="min-h-screen flex flex-col bg-background">
    <Header />

    <main class="flex-1 min-h-screen">
      <div class="container pt-20 pb-8 md:pt-24 md:pb-12">
        <slot />
      </div>
    </main>

    <Footer />
  </div>
</template>
